export enum ErrorCategory {
  Badges = 'Badges',
  Bid = 'Bid',
  Budget = 'Budget',
  Discourse = 'Discourse',
  Webhook = 'Webhook',
  Events = 'Events',
  Job = 'Job',
  Profile = 'Profile',
  Proposal = 'Proposal',
  Snapshot = 'Snapshot',
  Transparency = 'Transparency',
  Vesting = 'Vesting',
  Voting = 'Voting',
  Discord = 'Discord',
  Newsletter = 'Newsletter',
  Notifications = 'Notifications',
  Financial = 'Financial',
  Update = 'Update',
}
